export interface Testimonial {
  name: string
  location: string
  headline: string
  quote: string
  image: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Maria',
    location: 'United States',
    headline: 'It finally gave me a way to organize everything.',
    quote:
      "I've taken several courses on occlusion, but this feels completely different. I love having the information organized into an actual workflow.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e2f8c382-339c-4e5e-a3b2-02ad3d9a19eb.jpg',
  },
  {
    name: 'James',
    location: 'United Kingdom',
    headline: 'The decision maps are incredibly practical.',
    quote:
      'I can quickly see what I need to consider instead of going back through hours of notes.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2b804dc4-3ff8-4cb3-bb77-5930cfc041de.jpg',
  },
  {
    name: 'Andrea',
    location: 'Australia',
    headline: 'The checklists are what I use the most.',
    quote: 'They help me bring more structure to the way I review complex cases.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8f31d47e-8913-4144-876a-d1681818f507.jpg',
  },
  {
    name: 'Michael',
    location: 'United States',
    headline: "It doesn't feel like another ebook.",
    quote: 'It feels like a professional clinical reference manual.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b02e8d8a-a202-40b5-b240-7f375c29106b.jpg',
  },
  {
    name: 'Laura',
    location: 'Canada',
    headline: 'Everything organized in one place.',
    quote:
      "The biggest difference is having everything organized in one place. I don't have to keep searching through different courses and notes.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/76400237-3d4a-44bb-8462-37017daa3410.jpg',
  },
]
